import moment from 'moment'

const onLineRecordConf = {
  BASE_INFO: [
    {
      label: '姓名',
      class: 's',
      prop: 'name'
    },
    {
      label: '性别',
      class: 's',
      prop: 'gender',
      render: record => {
        const { gender } = record
        return gender || gender === 0 ? ['女', '男', '未知'][gender] : '--'
      }
    },
    {
      label: '年龄',
      class: 's',
      prop: 'age',
      render: record => {
        const { age, ageUnit } = record
        if (!age) return '--'
        return `${age} ${ageUnit || '岁'}`
      }
    },
    { label: '现病史 ', class: 'm', prop: 'presentDisease' },
    { label: '既往史', class: 'm', prop: 'pastHistory' },
    { label: '检查指标', class: 'l', prop: 'detailIndex' },
    { label: '更多检查结果', class: 'm', prop: 'moreExamine' },
    { label: '医生', class: 's', prop: 'doctorName' },
    { label: '科室', class: 's', prop: 'department' },
    { label: '互联网医院', class: 's', prop: 'hospitalName' },
    { label: '病历照片', class: 'l', type: 'img', prop: 'imgList' }
  ],
  CHINESE: [
    { label: '症状简述', class: 'm', prop: 'mainComplaint' },
    { label: '中医证型', class: 'm', prop: 'diagnosisInfoList' }
  ],
  // 协定方展示
  AGREEMENT: [
    { label: '症状简述', class: 'm', prop: 'mainComplaint' },
    { label: '诊断', class: 's', prop: 'westernDiagnosis' },
    { label: '中医证型', class: 's', prop: 'diagnosisInfoList' }
  ],
  WESTERN: [
    { label: '主诉', class: 'm', prop: 'mainComplaint' },
    { label: '临床诊断', class: 'm', prop: 'diagnosisInfoList' },
    { label: '嘱托', class: 'm', prop: 'taboo' }
  ],
  //联合处方新增
  COMMON: [
    { label: '主诉', class: 'm', prop: 'mainComplaint' },
    { label: '症状简述', class: 'm', prop: 'mainComplaint' },
    { label: '诊断', class: 'm', prop: 'westernDiagnosis' },
    { label: '中医证型', class: 'm', prop: 'chineseDiagnosis' },
    { label: '嘱托', class: 'm', prop: 'taboo' }
  ],
  CHINESE_DRUG: [
    { title: '编码', dataIndex: 'code', key: 'code' },
    { title: '药材名称', dataIndex: 'name', key: 'name' },
    { title: '计量（克）', dataIndex: 'gram', key: 'gram', slots: { customRender: 'gram' } }
  ],
  // 协定方药品信息
  AGREEMENT_DRUG: [
    // 编码协定方展示--@雅俊
    { title: '编码', dataIndex: 'prescriptionSn', key: 'prescriptionSn' },
    { title: '药方名称', dataIndex: 'prescriptionName', key: 'prescriptionName' }
  ],
  WESTERN_DRUG: [
    { title: 'sku 编码', dataIndex: 'skuNumber', key: 'skuNumber' },
    { title: 'sku 名称', dataIndex: 'medicationName', key: 'medicationName' },
    { title: '数量（盒）', dataIndex: 'quantity', key: 'quantity' },
    { title: '用法用量', dataIndex: 'usages', key: 'usages' },
    // {
    //   title: '销售价格（元）',
    //   dataIndex: 'price',
    //   key: 'price',
    //   slots: { customRender: 'price' }
    // },
    { title: '备注', dataIndex: 'bakup', key: 'bakup' }
  ],
  // 中药补充内容
  CHINESE_DRUG_ADD: [
    { label: '剂型', value: 'dosageTypeStr' },
    { label: '用法用量', value: 'usageDosage' },
    { label: '嘱托', value: 'taboo' },
    { label: '药房备注', value: 'pharmacyRemark' }
    // { label: '服用禁忌', value: 'taboo' },
    // { label: '医嘱', value: 'advice' },
  ],
  // 协定方
  AGREEMENT_DRUG_ADD: [
    { label: '剂型', value: 'dosageTypeStr' },
    { label: '用法用量', value: 'usageDosage' },
    { label: '用药周期', value: 'cycle' }, //只在协定方展示
    { label: '嘱托', value: 'taboo' },
    { label: '药房备注', value: 'pharmacyRemark' }
  ]
}
// 剂型
const dosageTypeConf = {
  1: '配方颗粒',
  2: '丸剂',
  3: '粉剂'
}
function momentFormat(d) {
  if (!d) return '--'
  return moment(d).format('YYYY-MM-DD')
}

const offLineRecordConf = {
  RECORD_INFO: [
    {
      label: '姓名',
      class: 's',
      prop: 'patientName',
      render: record => {
        return record.patientProfileCommonVO?.patientProfileName || '--'
      }
    },
    {
      label: '性别',
      class: 's',
      prop: 'patientProfileGender',
      render: record => {
        const { gender } = record?.patientProfileCommonVO || {}
        return [0, 1].includes(gender) ? (gender === 0 ? '女' : '男') : '--'
      }
    },
    {
      label: '年龄',
      class: 's',
      prop: 'patientAge',
      render: record => {
        const { age } = record?.patientProfileCommonVO || {}
        return age || age === 0 ? age + '岁' : '--'
      }
    },
    {
      label: '就诊时间',
      class: 's',
      prop: 'inquiryTime',
      render: record => {
        if (record.assistPermission !== 1) {
          return '--'
        }
        return record.inquiryTime || '--'
      }
    },
    { label: '就诊诊断', class: 'm', prop: 'offlineDiagnosis' },
    { label: '复诊日期', class: 'm', prop: 'cureReserveOrderVO' }
    // { label: '病情描述', class: 'l', prop: 'description' },
    // { label: '病历照片', class: 'l', type: 'img', prop: 'imgUrlList' }
    // { label: '就诊医院', class: 's', prop: 'offlineHospital' },
    // { label: '就诊科室', class: 's', prop: 'offlineDepartment' },
    // { label: '就诊医生', class: 's', prop: 'offlineDoctor' },
  ],
  // 只有门诊病历才会有
  DRUG_INFO: [
    {
      label: '活动名称',
      value: 'activityName',
      isShow: false,
      type: 'drug',
      render: (infoBase, record, v) => {
        if (!isShowValue(infoBase, true)) {
          return '--'
        }
        return v || '不参与活动'
      }
    },
    {
      label: '处方药品',
      value: 'medicationNames',
      class: 'l',
      isShow: true,
      render: (infoBase, record, v) => {
        if (!isShowValue(infoBase, true)) {
          return '--'
        }
        return infoBase.noMedication === 0 ? record.medicationNames.join('；') || '--' : '暂无用药'
      }
    },
    {
      label: '开始时间',
      value: 'beginTime',
      render: (infoBase, record, v) => {
        if (!isShowValue(infoBase, true)) {
          return '--'
        }
        return momentFormat(v)
      },
      isShow: false,
      type: 'drug'
    },
    {
      label: '用药周期',
      value: 'medicineCycle',
      isShow: false,
      type: 'drug',
      render: (infoBase, record, v) => {
        if (!isShowValue(infoBase, true)) {
          return '--'
        }
        return v + ' 天' || '--'
      }
    },
    {
      label: '结束时间',
      value: 'endTime',
      render: (infoBase, record, v) => {
        if (!isShowValue(infoBase, true)) {
          return '--'
        }
        return momentFormat(v)
      },
      isShow: false,
      type: 'drug'
    },
    {
      label: '病情描述',
      class: 'l',
      prop: 'description',
      value: 'description',
      isShow: true,
      render: infoBase => {
        if (!isShowValue(infoBase, true)) {
          return '--'
        }
        return infoBase.description || '--'
      }
    },
    { label: '病历图片', class: 'l', type: 'img', prop: 'imgUrlList', isShow: true },
    { label: '处方图片', class: 'l', type: 'img', prop: 'ocrImgUrlList', isShow: true }
    // {
    //   label: '处方图片',
    //   class: 'l',
    //   type: 'img',
    //   prop: 'prescriptionImages'
    // },
  ],
  // his门诊病历
  HIS_RECORD_INFO: [
    { label: '患者ID', class: 's', prop: 'ucPatientId' },
    { label: '就诊科室', class: 's', prop: 'medicalDepartment' },
    { label: '接诊医生', class: 's', prop: 'writingDoctor' },
    { label: '就诊时间', class: 's', prop: 'medicalDate' },
    { label: '主诉', class: 'l', prop: 'chiefComplaint' },
    { label: '现病史', class: 'l', prop: 'currentMedicalHistory' },
    { label: '既往史', class: 'l', prop: 'pastHistory' },
    { label: '个人史', class: 'l', prop: 'personHistory' },
    { label: '家族史', class: 'l', prop: 'familyHistory' },
    { label: '体格检查', class: 'l', prop: 'physiqueInspect' },
    { label: '辅助检查', class: 'l', prop: 'assistantInspect' },
    { label: '诊断', class: 'l', prop: 'diagnosisName' },
    { label: '处理', class: 'l', prop: 'handle' }
  ]
}

// 是否显示值
// isOnLine 是否是门诊病历
const isShowValue = (res, isOffLine) => {
  // 如果是门诊病历并且建管不可见的情况下值显示--
  if (isOffLine && res.assistPermission !== 1) {
    return false
  }
  return true
}
export { onLineRecordConf, offLineRecordConf, isShowValue, dosageTypeConf }
